import { render, staticRenderFns } from "./ProcessExceptionList.vue?vue&type=template&id=37090bbc&"
import script from "./ProcessExceptionList.vue?vue&type=script&lang=js&"
export * from "./ProcessExceptionList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports